import { Sun, Moon, Type } from 'lucide-react';
import { Dropdown } from './Dropdown';
import { useAccessibilitySettings } from '../../hooks/useAccessibilitySettings';

interface AccessibilityDropdownProps {
  adjustFontSize: (delta: number) => void;
  fontSize: number;
}

export function AccessibilityDropdown({ adjustFontSize, fontSize }: AccessibilityDropdownProps) {
  const { theme, toggleTheme } = useAccessibilitySettings();

  return (
    <Dropdown
      title={
        <div className="flex items-center gap-2">
          <Type className="w-4 h-4" />
          <span>Dostępność</span>
        </div>
      }
      to="#"
    >
      <div className="p-4 w-[280px] space-y-4" style={{ right: 0 }} aria-label="Menu dostępności">
        <div className="space-y-2">
          <span className="text-sm font-medium text-accessible-gray-900 dark:text-white high-contrast:text-white">Motyw</span>
          <div className="grid grid-cols-1 gap-2">
            <button
              onClick={() => {
                toggleTheme('light');
              }}
              className={`flex items-center gap-2 w-full py-2 px-3 rounded-lg transition-colors ${
                theme === 'light'
                  ? 'bg-accessible-red-600 text-white'
                  : 'text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10'
              }`}
            >
              <Sun className="w-4 h-4" />
              <span>Tryb jasny</span>
            </button>
            <button
              onClick={() => {
                toggleTheme('dark');
              }}
              className={`flex items-center gap-2 w-full py-2 px-3 rounded-lg transition-colors ${
                theme === 'dark'
                  ? 'bg-accessible-red-600 text-white'
                  : 'text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10'
              }`}
            >
              <Moon className="w-4 h-4" />
              <span>Tryb ciemny</span>
            </button>
            <button
              onClick={() => {
                toggleTheme('high-contrast');
              }}
              className={`flex items-center gap-2 w-full py-2 px-3 rounded-lg transition-colors ${
                theme === 'high-contrast'
                  ? 'bg-accessible-red-600 text-white'
                  : 'text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10'
              }`}
            >
              <Type className="w-4 h-4" />
              <span>Wysoki kontrast</span>
            </button>
          </div>
        </div>
        
        {/* Font Size Controls */}
        <div className="flex items-center justify-between gap-2 py-2" aria-label="Kontrola rozmiaru tekstu">
          <div className="flex items-center gap-1 flex-wrap" role="group">
            <button
              onClick={() => adjustFontSize(90 - fontSize)}
              className={`px-2 py-1 rounded-lg text-sm hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 ${Math.abs(fontSize - 90) < 6 ? 'bg-accessible-red-600 text-white' : 'text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white'}`}
              aria-label="Ustaw rozmiar tekstu: mały"
              title="Ustaw rozmiar tekstu: mały"
            >
              A-
            </button>
            <button
              onClick={() => adjustFontSize(115 - fontSize)}
              className={`px-2 py-1 rounded-lg text-sm hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 ${Math.abs(fontSize - 115) < 6 ? 'bg-accessible-red-600 text-white' : 'text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white'}`}
              aria-label="Ustaw rozmiar tekstu: średni"
              title="Ustaw rozmiar tekstu: średni"
            >
              A
            </button>
            <button
              onClick={() => adjustFontSize(130 - fontSize)}
              className={`px-2 py-1 rounded-lg text-sm hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 ${Math.abs(fontSize - 130) < 6 ? 'bg-accessible-red-600 text-white' : 'text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white'}`}
              aria-label="Ustaw rozmiar tekstu: duży"
              title="Ustaw rozmiar tekstu: duży"
            >
              A+
            </button>
            <button
              onClick={() => adjustFontSize(145 - fontSize)}
              className={`px-2 py-1 rounded-lg text-sm hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 ${Math.abs(fontSize - 145) < 6 ? 'bg-accessible-red-600 text-white' : 'text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white'}`}
              aria-label="Ustaw rozmiar tekstu: bardzo duży"
              title="Ustaw rozmiar tekstu: bardzo duży"
            >
              A++
            </button>
          </div>
        </div>
      </div>
    </Dropdown>
  );
}